// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"widgets": 0,
	"webpack_sharing_provide_default_lingui_core-webpack_sharing_provide_default_lingui_react-webp-f7b8f8": 0
};

__webpack_require__.f.j = function(chunkId, promises) {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(webpack_(container_remote_(base_((classe|constant|hook|store|util)s|i18n)|kfplatform_file(P(icker(|V2)|review)|Upload))|sharing_(consume_default_(classnames_classnames(\-webpack_sharing_consume_default_react(\-d\-e10dc7|_react)|)|lingui_(core_lingui_core\-_(208f|8210)|react_lingui_react)|prop\-types_prop\-types(\-webpack_sharing_consume_default_(prop\-ty\-5d2b1f|react_react)|)|react(\-dom_react\-dom\-_(4fbc|bb26)|_react\-_(4(464|4b2|75e)|01d1|25fe|3236|5f20|80df|cc5b|e6fd)))|provide_default_lingui_core\-webpack_sharing_provide_default_lingui_react\-webp\-f7b8f8))|vendors\-node_modules_pnpm_antd_4_9_2_biqbaboplfbrettd7655fr4n2y_node_modules_antd_es_style_in\-6d7e5b)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise(function(resolve, reject) { installedChunkData = installedChunks[chunkId] = [resolve, reject]; });
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = function(event) {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

__webpack_require__.F.j = function(chunkId) {
	if((!__webpack_require__.o(installedChunks, chunkId) || installedChunks[chunkId] === undefined) && !/^(webpack_(container_remote_(base_((classe|constant|hook|store|util)s|i18n)|kfplatform_file(P(icker(|V2)|review)|Upload))|sharing_(consume_default_(classnames_classnames(\-webpack_sharing_consume_default_react(\-d\-e10dc7|_react)|)|lingui_(core_lingui_core\-_(208f|8210)|react_lingui_react)|prop\-types_prop\-types(\-webpack_sharing_consume_default_(prop\-ty\-5d2b1f|react_react)|)|react(\-dom_react\-dom\-_(4fbc|bb26)|_react\-_(4(464|4b2|75e)|01d1|25fe|3236|5f20|80df|cc5b|e6fd)))|provide_default_lingui_core\-webpack_sharing_provide_default_lingui_react\-webp\-f7b8f8))|vendors\-node_modules_pnpm_antd_4_9_2_biqbaboplfbrettd7655fr4n2y_node_modules_antd_es_style_in\-6d7e5b)$/.test(chunkId)) {
		installedChunks[chunkId] = null;
		var link = document.createElement('link');

		if (__webpack_require__.nc) {
			link.setAttribute("nonce", __webpack_require__.nc);
		}
		link.rel = "prefetch";
		link.as = "script";
		link.href = __webpack_require__.p + __webpack_require__.u(chunkId);
		document.head.appendChild(link);
	}
};

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };

// install a JSONP callback for chunk loading
var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
	var chunkIds = data[0];
	var moreModules = data[1];
	var runtime = data[2];
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkwidgets"] = self["webpackChunkwidgets"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));